module.exports = __webpack_public_path__ + "img/12.37fd6f3c.jpg";